import {message} from 'antd';

function removeElement(_element) {
  const _parentElement = _element.parentNode;

  if (_parentElement) {
    _parentElement.removeChild(_element);
  }
}

export function toImages(canvas) {
  let image = new Image();
  // canvas.toDataURL 返回的是一串Base64编码的URL
  // 指定格式 PNG
  image.src = canvas.toDataURL('image/png');
  return image;
}

export function maxHeight4Dialog() {
  return window.innerHeight - 150 + 'px';
}

export function populateDpi() {
  const dpi = null;
  const s = window.screen;
  if (s.deviceXDPI !== undefined) {
    dpi.x = s.deviceXDPI;
    dpi.y = s.deviceYDPI;
  } else {
    const tmpNode = document.createElement('DIV');
    tmpNode.style.cssText =
      'width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden';
    document.body.appendChild(tmpNode);
    dpi.x = tmpNode.offsetWidth;
    dpi.y = tmpNode.offsetHeight;
    tmpNode.parentNode.removeChild(tmpNode);
  }
  return dpi;
}

// 页边距： 0.75 inch
// A4: 8.27x11.69 inch
// 打印机DPI：600DPI
// 屏幕DPI  : 96DPI
// width　=　(8.27 - 0.75 * 2) * 96 / 600 = 650 px
// height =  (11.69 - 0.75 * 2)* 96 / 600 = 978 px

const PageSize = {
  A4: { width: 8.27, height: 11.69 },
};

export function populatePxWidth(pageSize, padding, dpi) {
  return (PageSize[pageSize].width - padding * 2) * dpi.x;
}

export function populatePxHeight(pageSize, padding, dpi) {
  return (PageSize[pageSize].height - padding * 2) * dpi.y;
}

export function print(area, callback) {
  printWithOptions(area, { pageSize: 'A4', padding: 0.75 }, callback);
}

export function printWithOptions(area, options, callback,ms=100) {
  const iframeId = 'printArea_';
  let iframe = document.getElementById(iframeId);
  if (iframe !== null) {
    removeElement(iframe);
  }
  iframe = document.createElement('IFRAME');
  iframe.setAttribute('id', iframeId);
  iframe.setAttribute(
    'style',
    'position:absolute;width:0px;height:0px;left:-500px;top:-500px;'
  );
  iframe.setAttribute('href', '#');
  iframe.addEventListener('load', function() {
    console.log('print iframe loaded');
    const doc = iframe.contentDocument;
    if (area.tagName === 'IFRAME') {
      copyIframeContent(doc, area);
    } else {
      if (options && options.pageSize === 'A5') {
        const style = document.createElement("style");
        style.setAttribute('type', 'text/css');
        const text = doc.createTextNode(`
          @media print {
            @page {
              size: A5
            }
          }
        `);
        style.appendChild(text);
        doc.head.appendChild(style);
      }

      copyDivContent(doc, area);


      // doc.head.innerHTML = document.head.innerHTML;
      // doc.body.innerHTML = document.body.innerHTML;
    }
    // appendUserAndDate(doc, targetExp);
    if (callback) {
      callback(doc);
    }
    const frameWindow = iframe.contentWindow;
    frameWindow.focus();
    window.setTimeout(function() {
      frameWindow.print();
    }, ms);
  });
  document.body.appendChild(iframe);
}

function copyIframeContent(doc, area) {
  doc.head.innerHTML = area.contentDocument.head.innerHTML;
  doc.body.innerHTML = area.contentDocument.body.innerHTML;
  // appendPrintStyle(doc);
}

function copyDivContent(doc, area) {
  const arr = [];
  const links = document.querySelectorAll('link[rel=stylesheet],style');
  for (let i = 0; i < links.length; i++) {
    arr.push(links.item(i).outerHTML);
  }

  doc.head.innerHTML = arr.join('');
  doc.body.innerHTML = area.innerHTML;
  // appendPrintStyle(doc);
}

function appendPrintStyle(doc) {
  const styleText = `
      @page {
        size: auto;  /* auto is the initial value */
        /* margin: 0mm; this affects the margin in the printer settings */
        margin: 25mm;
        orphans: 4;
        windows: 4;
      }
      nav, aside {
        display: none;
      }
      .question, .scales-controls {
        page-break-inside: avoid;
      }
      table {
        page-break-inside: avoid;
      }
      .ck-box input {
        opacity: 1;
      }
      .ck-box label {
        visibility: hidden;
      }
      .dropdown-menu {
        display:none;
      }
      button[type=submit] {
        display:none;
      }
      .question-controls input, .question-controls textarea {
        border: 0px;
        border-bottom: 1px solid;
        border-radius: 0px;
      }
      .ant-checkbox-input {
        opacity: 1;
      }
      .ant-checkbox-inner {
        visibility: hidden;
      }
    `;
  const style = doc.createElement('style');
  const text = doc.createTextNode(styleText);
  style.setAttribute('media', 'print');
  // style.appendChild(text);
  doc.body.appendChild(style);
}

/**
 * 签名
 * @param {Document} doc
 * @param {string} targetExp
 */
export function appendUserAndDate(doc, targetExp) {
  const html = `
  <div style="margin: 10px 0px 20px 0px;">
      <table style="width:100%;">
        <tr><td>
        <span style="float:left; margin-left: 20px;">研究者签名:</span>
        <span style="float:left; border-bottom: 1px solid;width: 100px;height:25px;"></span>
        <span style="float:left; margin-left: 200px;">日期: 201</span>
        <span style="float:left; border-bottom: 1px solid;width: 30px;height:25px;"></span>
        <span style="float:left; ">年</span>
        <span style="float:left; border-bottom: 1px solid;width: 40px;height:25px;"></span>
        <span style="float:left; ">月</span>
        <span style="float:left; border-bottom: 1px solid;width: 40px;height:25px;"></span>
        <span style="float:left; ">日</span>
        </td></tr>
    </table>
  </div>
    `;
  let target = doc.body;
  if (targetExp) {
    target = doc.querySelector(targetExp);
  }
  target.insertAdjacentHTML('beforeend', html);
}

export function prependTitle(doc, targetExp, visitName, taskName) {
  const taskNameTr = taskName
    ? `<tr><td style="padding: 12px 0px;font-size: 18px;font-weight: bold;">${taskName}</td></tr>`
    : '';
  const html = `
    <div style="margin: 10px 0px 20px 0px;">
      <table style="width:100%;text-align:center;">
        <tr style="padding: 8px 0px;font-size: 15px"><td>${visitName}</td></tr>
        ${taskNameTr}
      </table>
    </div>
    `;
  let target = doc.body;
  if (targetExp) {
    target = doc.querySelector(targetExp);
  }
  target.insertAdjacentHTML('afterbegin', html);
}

export function fixAntdInput(doc) {
  const inputs = doc.querySelectorAll(
    '.ant-checkbox-checked>.ant-checkbox-input'
  );
  const length = inputs.length;
  for (let i = 0; i < length; i++) {
    const item = inputs.item(i);
    item.setAttribute('checked', 'checked');
  }
}

export const LodopPrintCase = (arg,cb) => {
  const {base64,html,cssStr} = arg;
  const LODOP = window.CLODOPA;
  if(!LODOP){
    message.error('请联系管理员安装打印插件！')
    cb && cb();
    return
  }
  const styleStr = '<style>' + cssStr + '</style>';
  const printHtml = '<!DOCTYPE html><div class="">' + styleStr + html.innerHTML + '</div>';
  //付款二维码 QR-print-div
  const QR = html.querySelector('.QR-print-div');
  if(QR){
    QR.style.display = 'none';
  }
  // if(QR){
  //   html.removeChild(QR)
  // }
  LODOP.PRINT_INIT("全院电子病历");

  LODOP.ADD_PRINT_HTM(1,1,'99%','94%',printHtml);
  // LODOP.SET_PRINT_STYLEA(0,"Horient",2);
  LODOP.SET_PRINT_STYLEA(0,"Vorient",1);

  if(QR){
    const QRDiv = '<div>' + styleStr + '<div class="QR-print-div1">' + html.querySelector('.QR-print-div').innerHTML + '</div>' + '</div>';
    LODOP.ADD_PRINT_HTM(1,1,"100%",'100%',QRDiv);
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"LinkNewPage",true);
  }
  
  const footerHtml = '<div>' + styleStr + html.querySelector('.print-table-box-footer').innerHTML + '</div>';

  LODOP.ADD_PRINT_HTM(740,1,"100%",'100%',footerHtml);
  LODOP.SET_PRINT_STYLEA(0,"ItemType",1);
  LODOP.SET_PRINT_STYLEA(0,"Horient",1);
  LODOP.SET_PRINT_STYLEA(0,"Vorient",1);

  LODOP.SET_LICENSES("","AD8A58091F0F91A27CF4F67C38888EAE","","");

  let canSetPrint = LODOP.SET_PRINTER_INDEX('PrintCase-FGL');
  // console.log(canSetPrint)
  if(!canSetPrint){
    LODOP.SET_PRINTER_INDEX(-1);
  }
  // LODOP.PREVIEW(); //预览打印
  LODOP.PRINT(); //直接打印
  cb && cb();
}
